__turbopack_context__.v({
  "card": "DriveFloatingToast-module__M_COgq__card",
  "cta": "DriveFloatingToast-module__M_COgq__cta",
  "dismissButton": "DriveFloatingToast-module__M_COgq__dismissButton",
  "glow": "DriveFloatingToast-module__M_COgq__glow",
  "header": "DriveFloatingToast-module__M_COgq__header",
  "icon": "DriveFloatingToast-module__M_COgq__icon",
  "spotlight": "DriveFloatingToast-module__M_COgq__spotlight",
});
